import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { ApplicationPipesModule } from 'src/app/shared/module/applicationPipesModule';
import { ScSensorGridComponent } from './sensor-grid/sc-sensor-grid.component';
import { ScSensorPanelComponent } from './sc-sensor-panel.component';

@NgModule({
  declarations: [ScSensorGridComponent, ScSensorPanelComponent],
  imports: [
    CommonModule,
    TranslateModule,
    AngularMaterialModule,
    ApplicationPipesModule,
  ],
  exports: [ScSensorPanelComponent],
})
export class ScSensorPanelModule {}
